import { render } from "./EstateDetailSwiper.vue?vue&type=template&id=2c515c16&scoped=true"
import script from "./EstateDetailSwiper.vue?vue&type=script&lang=js"
export * from "./EstateDetailSwiper.vue?vue&type=script&lang=js"

import "./EstateDetailSwiper.vue?vue&type=style&index=0&id=2c515c16&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c515c16"]])

export default __exports__